webpackJsonp([1,2],{

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(76)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(86),
  /* scopeId */
  "data-v-3b8ea682",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StyleEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_reset_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_reset_css__);









/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    StyleEditor: __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor___default.a,
    ResumeEditor: __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor___default.a
  },
  data: function data() {
    return {
      interval: 10,
      currentStyle: '',
      enableHtml: false,
      fullStyle: ['/*\n* Hello everyone\uFF0C\u6211\u662Fchenfx \u2014\u2014 \u4E00\u4E2A"\u5B66\u6E23"\n* \u770B\u4E86\u5927\u795E\u7684\u9879\u76EE\uFF0C\u53D7\u5230\u542F\u53D1\uFF0C\u60F3\u81EA\u5DF1\u4E5F\u6765\u6574\u4E00\u6CE2\uFF0C\u987A\u4FBF\u819C\u62DC\u4E00\u4E0B\u5927\u795E\n* \u4E0B\u9762\u5373\u5C06\u5F00\u59CB\uFF1A\n* let\'s go\u2026\u2026\u2026\u2026\u2026\u2026\n\n*/\n\n/* \u6765\u4E00\u6CE2\u8FC7\u6E21\u6548\u679C */\n* {\n  -webkit-transition: all .3s;\n  transition: all .3s;\n}\n/* \u5343\u7BC7\u4E00\u5F8B\u7684\u767D\u8272\uFF0C\u6211\u4EEC\u6765\u70B9\u513F\u5176\u5B83\u80CC\u666F */\nhtml {\n  color: #f60;\n  background: #505050;\n}\n/* \u6587\u5B57\u79BB\u8FB9\u6846\u592A\u8FD1\u4E86 */\n.styleEditor {\n  padding: .5em;\n  border: 1px solid #f60;\n  margin: .5em;\n  overflow: auto;\n  overflow-x: hidden;\n  width: 45vw;\n  height: 96vh;\n}\n\n\n/* 3D \u6548\u679C\u66F4\u70AB\u9177 */\nhtml{\n  -webkit-perspective: 1000px;\n          perspective: 1000px;\n}\n/* \u4F4D\u7F6E\u632A\u4E00\u632A \u5404\u4F4D\u6362\u4E2A\u5750 */\n.styleEditor {\n  position: fixed;\n  left: 0;\n  top: 0;\n  transform: translateX(110%) rotateY(-370deg) translateZ(-100px);\n}\n\n/* \u63A5\u4E0B\u6765\u4E00\u4E2A\u52C9\u5F3A\u53EF\u7528\u7684\u7F16\u8F91\u5668\uFF0C\u7ED9\u81EA\u5DF1\u4E00\u70B9\u513F"shen\u529B" */\n.resumeEditor{\n  position: fixed;\n  right: 0;\n  top: 0;\n  -webkit-transition: all 3s;\n  transition: all 3s;\n  transform: rotateY(360deg) translateX(-100%) rotateY(10deg) translateZ(-100px);\n  padding: .5em;\n  margin: .5em;\n  width: 48vw;\n  height: 96vh;\n  border: 1px solid #f60;\n  background: #505050;\n  color: #f60;\n  overflow: auto;\n}\n/* \u6CA1\u4EC0\u4E48\u5199\u7684\uFF0C\u53EA\u80FD\u62FF\u81EA\u5DF1\u7684\u7B80\u5386\u7EC3\u7EC3\u624B */\n\n\n', '\n/* \u8FD9\u4E2A\u7B80\u5386\u597D\u50CF\u5DEE\u70B9\u4EC0\u4E48\n * \u5BF9\u4E86\uFF0C\u8FD9\u662F Markdown \u683C\u5F0F\u7684\uFF0C\u6211\u9700\u8981\u53D8\u6210\u5BF9 HR \u66F4\u53CB\u597D\u7684\u683C\u5F0F\n * \u7B80\u5355\uFF0C\u7528\u5F00\u6E90\u5DE5\u5177\u7FFB\u8BD1\u6210 HTML \u5C31\u884C\u4E86\n */\n', '\n/* \u518D\u5BF9 HTML \u52A0\u70B9\u6837\u5F0F */\n.resumeEditor{\n  background:#505050;\n  padding: 2em;\n  height: 96vh;\n  color: #f60;\n}\n.resumeEditor h2{\n  display: inline-block;\n  border-bottom: 1px solid;\n  margin: 1em 0 .5em;\n}\n.resumeEditor ul,.resumeEditor ol{\n  list-style: none;\n}\n.resumeEditor ul> li::before{\n  content: \'\u2022\';\n  margin-right: .5em;\n}\n.resumeEditor ul li a{\n  color: #f60;\n}\n.resumeEditor ol {\n  counter-reset: section;\n}\n.resumeEditor ol li::before {\n  counter-increment: section;\n  content: counters(section, ".") " ";\n  margin-right: .5em;\n}\n.resumeEditor blockquote {\n  margin: 1em;\n  padding: .5em;\n  background: #ddd;\n}\n\n\n/*\n**\u25E2\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u25E3\u3000\u3000\u3000\u3000\u3000\u3000\u3000\n**\u3000\u3000\u3000\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u3000\u3000\u3000\u3000\u3000\u3000\u3000\n**\u3000\u3000\u3000\u2588\u2588\u3000\u3000\u3000\u25E5\u2588\u2588\u25E4\u3000\u3000\u3000\u2588\u2588\u3000\u3000\u3000\u3000\u3000\u3000\u3000\n**\u3000\u25E2\u2588\u2588\u2588\u3000\u3000\u3000\u3000\u25E5\u25E4\u3000\u3000\u3000\u3000\u2588\u2588\u25E3\u3000\u3000\u3000\u3000\u3000\u3000\n**\u3000\u258A\u258E\u2588\u2588\u25E3\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u25E2\u2588\u258A\u258A\u3000\u3000\u3000\u3000\u3000\u3000\n**\u3000\u258A\u258E\u2588\u2588\u25E4\u3000\u3000\u25CF\u3000\u3000\u25CF\u3000\u3000\u25E5\u2588\u258A\u258A\u3000\u3000\u3000\u3000\u3000\n**\u3000\u258A\u3000\u2588\u2588\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u2588\u258A\u258A\u3000\u3000\u3000\u3000\u3000\u3000\n**\u3000\u25E5\u2587\u2588\u2588\u3000\u258A\u3000\u3000\u3000\u3000\u3000\u3000\u258A\u3000\u2588\u2587\u25E4\u3000\u3000\u3000\u3000\u3000\u3000\n**\u3000\u3000\u3000\u2588\u2588\u3000\u25E5\u2586\u2584\u2584\u2584\u2584\u2586\u25E4\u3000\u2588\u258A\u3000\u3000\u3000\u25E2\u2587\u2587\u25E3\n**\u25E2\u2588\u2588\u25E5\u25E5\u2586\u2585\u2584\u2582\u2582\u2582\u2582\u2584\u2585\u2586\u2588\u2588\u2588\u25E3\u3000\u258A\u25E2\u3000\u2588\n**\u2588\u2573\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u2573\u2588\u3000\u25E5\u25E4\u25E2\u25E4\n**\u25E5\u2588\u25E3\u3000\u3000\u3000\u02D9\u3000\u3000\u3000\u3000\u3000\u02D9\u3000\u3000\u3000\u25E2\u2588\u25E4\u3000\u3000\u25E2\u25E4\u3000\n**\u3000\u3000\u258A\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u258A\u3000\u3000\u3000\u3000\u2588\u3000\u3000\n**\u3000\u3000\u258A\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u3000\u258A\u3000\u3000\u3000\u25E2\u25E4\u3000\u3000\n**\u3000\u3000\u258A\u3000\u3000\u3000\u3000\u3000\u3000\u2295\u3000\u3000\u3000\u3000\u3000\u3000\u2588\u2587\u2587\u2587\u25E4\u3000\u3000\n**\u3000\u25E2\u2588\u2587\u2586\u2586\u2586\u2585\u2585\u2585\u2585\u2586\u2586\u2586\u2587\u2588\u25E3\u3000\u3000\u3000\u3000\u3000\u3000\n**\u3000\u258A\u3000\u2582\u3000\u258A\u3000\u3000\u3000\u3000\u3000\u3000\u258A\u3000\u2582\u3000\n**\n*/\n\n\n\n\u57FA\u4E8Estrml.net\u7075\u611F\ncopyright\xA9chenfx\n'],
      currentMarkdown: '',
      fullMarkdown: '\u9648\u53D1\u7965\n----\n* \u6BD5\u4E1A\u9662\u6821\uFF1A\u91CD\u5E86\u5E08\u8303\u5927\u5B66\n* \u4E13\u4E1A\uFF1A\u8BA1\u7B97\u673A\u79D1\u5B66\u4E0E\u6280\u672F\n* \u5E74\u9F84\uFF1AXXX\n* \u6280\u672F\u65B9\u5411\uFF1A\u524D\u7AEF\u5DE5\u7A0B\u5E08\u3001.NET\u5F00\u53D1\u3001\u5D4C\u5165\u5F0F\u5F00\u53D1\n* \u7231\u597D: \u722C\u5C71\u3001\u7BEE\u7403\n* \u76EE\u6807\uFF1A\u5C0F\u5C0F\u7684\u5929\u5927\u5927\u7684\u68A6\u60F3\u2026\u2026\n\n\n\u6280\u80FD\n----\n\n* HTML \u5F00\u53D1\n* Node.js \u5F00\u53D1\n* .NET\u5F00\u53D1\n* \u5D4C\u5165\u5F0F\u5F00\u53D1\u2014\u2014\u54C8\u54C8\u54C8\n\n\u5DE5\u4F5C\u7ECF\u5386\n----\n\n### 2015.07 \u2014\u2014 2015.09 \u91CD\u5E86\u542F\u9AD8\u79D1\u6280\u6709\u9650\u516C\u53F8\u524D\u7AEF\u5B9E\u4E60\n\n* \u53C2\u4E0E\u516C\u53F8\u5E73\u53F0\u7684\u9875\u9762\u5F00\u53D1\n\n### 2015.09 - \u81F3\u4ECA \u91CD\u5E86\u732A\u516B\u6212\u7F51\u7EDC\u6709\u9650\u516C\u53F8 - \u524D\u7AEF\u5DE5\u7A0B\u5E08\n\n* \u6B63\u5F0F\u4ECE\u4E8B\u524D\u7AEF\u5F00\u53D1\u5DE5\u4F5C\n\n\u53CB\u60C5\u94FE\u63A5\n----\n\n* [blog](http://www.chenfx.com.cn/)\n* [GitHub](https://github.com/chenfaxiang)\n\n\n'
    };
  },
  created: function created() {
    this.makeResume();
  },


  methods: {
    makeResume: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.progressivelyShowStyle(0);

              case 2:
                _context.next = 4;
                return this.progressivelyShowResume();

              case 4:
                _context.next = 6;
                return this.progressivelyShowStyle(1);

              case 6:
                _context.next = 8;
                return this.showHtml();

              case 8:
                _context.next = 10;
                return this.progressivelyShowStyle(2);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function makeResume() {
        return _ref.apply(this, arguments);
      }

      return makeResume;
    }(),
    showHtml: function showHtml() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.enableHtml = true;
        resolve();
      });
    },
    progressivelyShowStyle: function progressivelyShowStyle(n) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var interval = _this2.interval;
        var showStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
          var _this3 = this;

          var style, length, prefixLength, l, char;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  style = this.fullStyle[n];

                  if (style) {
                    _context2.next = 3;
                    break;
                  }

                  return _context2.abrupt('return');

                case 3:
                  length = this.fullStyle.filter(function (_, index) {
                    return index <= n;
                  }).map(function (item) {
                    return item.length;
                  }).reduce(function (p, c) {
                    return p + c;
                  }, 0);
                  prefixLength = length - style.length;

                  if (this.currentStyle.length < length) {
                    l = this.currentStyle.length - prefixLength;
                    char = style.substring(l, l + 1) || ' ';

                    this.currentStyle += char;
                    if (style.substring(l - 1, l) === '\n' && this.$refs.styleEditor) {
                      this.$nextTick(function () {
                        _this3.$refs.styleEditor.goBottom();
                      });
                    }
                    setTimeout(showStyle, interval);
                  } else {
                    resolve();
                  }

                case 6:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        })).bind(_this2);
        showStyle();
      });
    },
    progressivelyShowResume: function progressivelyShowResume() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var length = _this4.fullMarkdown.length;
        var interval = _this4.interval;
        var showResume = function showResume() {
          if (_this4.currentMarkdown.length < length) {
            _this4.currentMarkdown = _this4.fullMarkdown.substring(0, _this4.currentMarkdown.length + 1);
            var lastChar = _this4.currentMarkdown[_this4.currentMarkdown.length - 1];
            var prevChar = _this4.currentMarkdown[_this4.currentMarkdown.length - 2];
            console.log(prevChar);
            if (prevChar === '\n' && _this4.$refs.resumeEditor) {
              _this4.$nextTick(function () {
                return _this4.$refs.resumeEditor.goBottom();
              });
            }
            setTimeout(showResume, interval);
          } else {
            resolve();
          }
        };
        showResume();
      });
    }
  }
};

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);



/* harmony default export */ __webpack_exports__["default"] = {
  props: ['markdown', 'enableHtml'],
  name: 'ResumeEditor',
  computed: {
    result: function result() {
      return this.enableHtml ? __WEBPACK_IMPORTED_MODULE_0_marked___default()(this.markdown) : this.markdown;
    }
  },
  methods: {
    goBottom: function goBottom() {
      this.$refs.container.scrollTop = 100000;
    }
  }
};

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Editor',
  props: ['code'],
  computed: {
    highlightedCode: function highlightedCode() {
      return __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlight(this.code, __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.languages.css);
    },
    codeInStyleTag: function codeInStyleTag() {
      return '<style>' + this.code + '</style>';
    }
  },
  methods: {
    goBottom: function goBottom() {
      this.$refs.container.scrollTop = 100000;
    }
  }
};

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 76:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 77:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(75)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(85),
  /* scopeId */
  "data-v-1f6f7918",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(77)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(87),
  /* scopeId */
  "data-v-b4c4f818",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "resumeEditor",
    class: {
      htmlMode: _vm.enableHtml
    }
  }, [(_vm.enableHtml) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.result)
    }
  }) : _c('pre', [_vm._v(_vm._s(_vm.result))])])
},staticRenderFns: []}

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('StyleEditor', {
    ref: "styleEditor",
    attrs: {
      "code": _vm.currentStyle
    }
  }), _vm._v(" "), _c('ResumeEditor', {
    ref: "resumeEditor",
    attrs: {
      "markdown": _vm.currentMarkdown,
      "enableHtml": _vm.enableHtml
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "styleEditor"
  }, [_c('div', {
    staticClass: "code",
    domProps: {
      "innerHTML": _vm._s(_vm.codeInStyleTag)
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.highlightedCode)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ })

},[89]);


// WEBPACK FOOTER //
// static/js/app.59e4c7180c0851d5eea0.js